import { PageLoader } from '../components/common/PageLoader';

export const ChunkReloadFallback = () => null;

export const PageFallback = () => (
  <PageLoader label="Cargando modulo" />
);
